module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box text-center"
  }, [_c('div', {
    staticClass: "box-body form"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('h3', [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "ad-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6 ad-form-left"
  }, [_c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.name),
      expression: "adInfo.name"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "45"
    },
    domProps: {
      "value": (_vm.adInfo.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adInfo, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.is_active),
      expression: "adInfo.is_active"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adInfo, "is_active", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("啟用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("停用")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.bannerType !== 41) ? _c('div', [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("\n          連結\n        ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.url),
      expression: "adInfo.url"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "",
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.adInfo.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.adInfo, "url", $event.target.value)
      }
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', [_c('div', {
    staticClass: "input-group cr-schedule cr-ad"
  }, [_vm._m(2), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.start,
      "option": _vm.timeoption,
      "limit": _vm.startLimit
    }
  })], 1), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "input-group cr-schedule cr-ad"
  }, [_vm._m(3), _vm._v(" "), _c('date-time-picker', {
    attrs: {
      "date": _vm.menuTime.end,
      "option": _vm.timeoption,
      "limit": _vm.endLimit
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [(_vm.bannerType !== 41) ? _c('div', {
    staticClass: "input-group"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "form-group select-right"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.foreverShow),
      expression: "adInfo.foreverShow"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.adInfo, "foreverShow", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("是")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("否")])])])]) : _vm._e()])])]), _vm._v(" "), (_vm.bannerType !== 41) ? _c('div', {
    staticClass: "row"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-12 flex"
  }, [_c('div', {
    staticClass: "cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("廣告地區\n        "), _c('span', {
    staticClass: "nd-tooltip"
  }, [_c('ion-icon', {
    attrs: {
      "name": "help-circle"
    }
  }), _vm._v(" "), _vm._m(5)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block cell-right"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.is_limit_location),
      expression: "adInfo.is_limit_location"
    }],
    attrs: {
      "type": "radio",
      "name": "is_limit_location"
    },
    domProps: {
      "value": 0,
      "checked": _vm._q(_vm.adInfo.is_limit_location, 0)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adInfo, "is_limit_location", 0)
      }
    }
  }), _vm._v("\n          不限制\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "ml-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.adInfo.is_limit_location),
      expression: "adInfo.is_limit_location"
    }],
    attrs: {
      "type": "radio",
      "name": "is_limit_location"
    },
    domProps: {
      "value": 1,
      "checked": _vm._q(_vm.adInfo.is_limit_location, 1)
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.adInfo, "is_limit_location", 1)
      }
    }
  }), _vm._v("\n          指定區域\n        ")])])]), _vm._v(" "), (_vm.adInfo.is_limit_location) ? _c('div', [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_vm._m(6), _vm._v(" "), _c('multiselect', {
    staticClass: "min-w-150",
    attrs: {
      "options": _vm.getCityOption,
      "searchable": false,
      "allow-empty": true,
      "close-on-select": false,
      "show-labels": false,
      "placeholder": "",
      "multiple": true,
      "label": "name",
      "track-by": "code"
    },
    model: {
      value: (_vm.adInfo.city_code_list),
      callback: function($$v) {
        _vm.$set(_vm.adInfo, "city_code_list", $$v)
      },
      expression: "adInfo.city_code_list"
    }
  })], 1)]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "upload-image"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon w-100-p text-center p-all-0 bg-white",
    staticStyle: {
      "border-right": "none"
    }
  }, [_c('span', {
    staticClass: "inline-block h-auto"
  }, [(!_vm.adInfo.image_web_file) ? _c('img', {
    staticClass: "img-responsive h-auto",
    attrs: {
      "src": _vm.defaultImage
    }
  }) : _vm._e(), _vm._v(" "), (_vm.adInfo.image_web_file) ? _c('img', {
    staticClass: "h-auto img-responsive",
    attrs: {
      "src": _vm.adInfo.image_web_file,
      "data-toggle": "modal"
    }
  }) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-control h-100"
  }, [_c('div', [_c('label', {
    staticClass: "btn-upload btn btn-default m-t-25",
    staticStyle: {
      "margin-top": "8px"
    },
    attrs: {
      "for": "brand-img-load"
    }
  }, [_vm._v("\n          選擇圖片\n        ")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "brand-img-load"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "text-right text-15 text-red",
    domProps: {
      "textContent": _vm._s(_vm.tipsImage)
    }
  }), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "row store-bannder"
  }, [_vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-12 flex"
  }, [_vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block cell-right"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCopyStore),
      expression: "isCopyStore"
    }],
    attrs: {
      "type": "radio",
      "name": "setStore"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.isCopyStore, true)
    },
    on: {
      "change": function($event) {
        _vm.isCopyStore = true
      }
    }
  }), _vm._v("\n          是\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "ml-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isCopyStore),
      expression: "isCopyStore"
    }],
    attrs: {
      "type": "radio",
      "name": "setStore"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.isCopyStore, false)
    },
    on: {
      "change": function($event) {
        _vm.isCopyStore = false
      }
    }
  }), _vm._v("\n          否\n        ")])])]), _vm._v(" "), (_vm.isCopyStore) ? _c('div', {
    staticClass: " col-12 text-left m-t-25"
  }, [_c('h5', [_vm._v("參與店家")]), _vm._v(" "), _c('div', _vm._l((_vm.storeClassList), function(storeClass, index) {
    return _c('div', {
      staticClass: "m-r-5 m-b-10 inline-block"
    }, [_c('button', {
      staticClass: "btn btn-default",
      class: {
        'active': _vm.curId === storeClass.id
      },
      on: {
        "click": function($event) {
          return _vm.clickOption(storeClass)
        }
      }
    }, [_vm._v("\n            " + _vm._s(storeClass.name) + "\n          ")])])
  }), 0), _vm._v(" "), _c('muti-select-two', {
    attrs: {
      "setting": _vm.addStoresSetting,
      "reNew": _vm.reNew,
      "reSet": _vm.reSet
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 flex"
  }, [_vm._m(10), _vm._v(" "), _c('div', {
    staticClass: "radio inline-block cell-right"
  }, [_c('label', {
    style: (_vm.adInfo.is_active === '0' ? 'color: #C2C2C2' : '')
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isJkosOpen),
      expression: "isJkosOpen"
    }],
    attrs: {
      "disabled": _vm.adInfo.is_active === '0',
      "type": "radio",
      "name": "setJkos"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.isJkosOpen, true)
    },
    on: {
      "change": function($event) {
        _vm.isJkosOpen = true
      }
    }
  }), _vm._v("\n          啟用\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "ml-5"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isJkosOpen),
      expression: "isJkosOpen"
    }],
    attrs: {
      "type": "radio",
      "name": "setJkos"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.isJkosOpen, false)
    },
    on: {
      "change": function($event) {
        _vm.isJkosOpen = false
      }
    }
  }), _vm._v("\n          停用\n        ")])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "box-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), (!_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('cr')
      }
    }
  }, [_vm._v("\n      新增\n    ")]) : _vm._e(), _vm._v(" "), (_vm.info) ? _c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.checkBeforeSend('up')
      }
    }
  }, [_vm._v("\n      修改\n    ")]) : _vm._e()]), _vm._v(" "), _c('br')])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("名稱\n      ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("啟用\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("開始時間\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("結束時間\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("永久顯示\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "nd-tooltip-text center"
  }, [_vm._v("\n            *依據消費者位置指定廣告要出現的縣市(目前限台灣地區)。"), _c('br'), _vm._v("\n            *若無法判斷位置或在非台灣地區，則預設都顯示。\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("指定區域\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "input-group-addon"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("圖片\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', [_vm._v("套用門市設定")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("套用門市")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell"
  }, [_c('span', {
    staticClass: "text-red"
  }, [_vm._v("＊ ")]), _vm._v("街口平台\n      "), _c('span', {
    staticClass: "tip-icon",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "與街口支付APP合作之你訂獨家功能，有興趣可洽業務窗口。若未簽約合作請勿啟用。"
    }
  }, [_c('i', {
    staticClass: "fa fa-question-circle",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37f8f61c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Brand/Temp/BrandAdFormTemp.vue
// module id = 2381
// module chunks = 1